import { get } from "../../service/api";

const GetSubMerchants = async () => {
  try {
    const response = await get(`/admin/subMerchant/dropdown`);
    return response;
  } catch (error) {
    console.error("Error GetSubMerchants:", error);
    throw error;
  }
};

export default GetSubMerchants;
